export default __webpack_public_path__ + "static/media/blog-HOA-pavers-005.bdedd62f.png";